import { GLTFLoader, ArrayItem } from "../glTFLoader";
var NAME = "KHR_texture_basisu";
/**
 * [Proposed Specification](https://github.com/KhronosGroup/glTF/pull/1751)
 * !!! Experimental Extension Subject to Changes !!!
 */

var KHR_texture_basisu = function () {
  /** @hidden */
  function KHR_texture_basisu(loader) {
    /** The name of this extension. */
    this.name = NAME;
    this._loader = loader;
    this.enabled = loader.isExtensionUsed(NAME);
  }
  /** @hidden */


  KHR_texture_basisu.prototype.dispose = function () {
    this._loader = null;
  };
  /** @hidden */


  KHR_texture_basisu.prototype._loadTextureAsync = function (context, texture, assign) {
    var _this = this;

    return GLTFLoader.LoadExtensionAsync(context, texture, this.name, function (extensionContext, extension) {
      var sampler = texture.sampler == undefined ? GLTFLoader.DefaultSampler : ArrayItem.Get(context + "/sampler", _this._loader.gltf.samplers, texture.sampler);
      var image = ArrayItem.Get(extensionContext + "/source", _this._loader.gltf.images, extension.source);
      return _this._loader._createTextureAsync(context, sampler, image, function (babylonTexture) {
        assign(babylonTexture);
      }, texture._textureInfo.nonColorData ? {
        useRGBAIfASTCBC7NotAvailableWhenUASTC: true
      } : undefined);
    });
  };

  return KHR_texture_basisu;
}();

export { KHR_texture_basisu };
GLTFLoader.RegisterExtension(NAME, function (loader) {
  return new KHR_texture_basisu(loader);
});